import { z } from 'zod';

export const RequestApprovalReviewSchema = z.object({
  comment: z.string().nonempty(),
  file: z.any(),
});

export type RequestApprovalReviewForm = z.infer<
  typeof RequestApprovalReviewSchema
>;
